import { render, staticRenderFns } from "./ElEchart.vue?vue&type=template&id=96c1dc4c&scoped=true&"
import script from "./ElEchart.vue?vue&type=script&lang=ts&"
export * from "./ElEchart.vue?vue&type=script&lang=ts&"
import style0 from "./ElEchart.vue?vue&type=style&index=0&id=96c1dc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c1dc4c",
  null
  
)

export default component.exports